import { disasterAssistanceHardshipLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data, userInfo, stepWhatHappenedData, nameClaimType) {
  const expenses = mapToExpenseStep(data, userInfo, stepWhatHappenedData, nameClaimType);
  return [...expenses];
}

function mapToExpenseStep(data, userInfo, stepWhatHappenedData, nameClaimType) {
  const expenses = [];
  if (nameClaimType === 'Disaster Assistance Hardship') {
    const claimCode = expenseLookup.disasterAssistanceHardship.claimCode;
    const listFieldMapDes = [data.nameOfYourHomeownersRentersInsuranceCarrier, data.yourHomeownersRentersPolicyNumber, data.yourClaimNumberWithYourCarrier];
    const description = listFieldMapDes.filter((x) => x).join(' | ');
    const expense = mapExpenseItem(data, nameClaimType, userInfo, stepWhatHappenedData, claimCode, description);
    expenses.push(expense);
  }
  return expenses;
}

function mapExpenseItem(data, nameClaimType, userInfo, stepWhatHappenedData, claimCode, description) {
  return {
    shortDescription: description,
    dateOfExpense: data.dateTheDisasterOccurred,
    clientCost: stepWhatHappenedData.whatIsTheOutstandingDuesAmount,
    currency: stepWhatHappenedData.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
    claimFor: userInfo.name,
    nameClaimType,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepDisasterAssistanceHardshipDataMapper.js